import React, { useEffect } from 'react';
import { Alert } from '../../../../CommonComponents/OPL/Alert/Alert';
import {
  UPSERT_INCOME_FORM_ID,
  UpsertIncomeFormProps,
} from '../../components/UpsertIncomeModal/UpsertIncomeModal.meta';
import { EmploymentFormFields } from './EmploymentFormFields';
import { useEmploymentForm } from './useEmploymentForm';

export type Props = UpsertIncomeFormProps;

export const EmploymentForm = ({ clientId, income, data, onSuccess, onDirtyChange, readOnly }: Props) => {
  const {
    data: { formBag, mutationBag, defaultShowAdvanced },
    actions: { onSubmit, resetValues },
  } = useEmploymentForm({ clientId, income, data, onSuccess, readOnly });

  const {
    formState: { isDirty },
  } = formBag;

  useEffect(() => {
    onDirtyChange?.(isDirty);
  }, [isDirty, onDirtyChange]);

  useEffect(() => {
    resetValues();
  }, [income]);

  return (
    <form
      onSubmit={onSubmit}
      id={UPSERT_INCOME_FORM_ID}
      css={`
        display: flex;
        flex-direction: column;
        gap: 16px;
      `}
      aria-label="Employment income form"
    >
      {mutationBag.error && (
        <Alert
          variant="error"
          message={mutationBag.error.message}
          onRequestClose={mutationBag.reset}
        />
      )}

      <EmploymentFormFields
        formBag={formBag}
        options={data.Options}
        defaultShowAdvanced={defaultShowAdvanced}
      />
    </form>
  );
};
